module.exports = __webpack_public_path__ + "static/media/HowToAdbop_Mobile_SV_2.406ea06c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HowToAdbop_Mobile_SV_2.png
// module id = 581
// module chunks = 0